module.exports = __webpack_public_path__ + "static/SS-eded4c0a9aed3963b3b12db53f6d77e1.jpg";